const INACTIVE = 'INACTIVE'; 

function getProjects(edges) {
  return edges.map(({ node }) => node).filter(node => node.status !== INACTIVE);
}

export default getProjects;



// WEBPACK FOOTER //
// ./src/utils/getProjects.js